@if (!usePdfKitViewer) {
  <app-pdf-file-viewer
    [height]="height"
    [class]="pdfFileViewerClass"
    [pdfFile]="pdfFile"
    [pdfFileType]="pdfFileType" />
}
@if (usePdfKitViewer) {
  <app-pdfkit-file-viewer
    [height]="height"
    [class]="pdfKitViewerClass"
    [containerClass]="pdfKitViewerContainerClass"
    [pdfFile]="pdfFile"
    [pdfFileType]="pdfFileType"
    [editable]="editable"
    (urlChange)="onUrlChange($event)" />
}
